import React, { useState } from 'react';
import { TiArrowBack } from "react-icons/ti";
import './CardSelector.css';

const CardSelector = ({ onCardSelect, onBack }) => {
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [showAddCardForm, setShowAddCardForm] = useState(false);
  const [newCard, setNewCard] = useState({
    number: '',
    name: '',
    expiry: '',
    cvv: ''
  });

  const savedCards = [
    {
      id: 1,
      type: 'visa',
      number: '**** 1234',
      lastFour: '1234',
      name: 'JOHN DOE',
      expiry: '12/25',
      bank: 'Chase Bank'
    },
    {
      id: 2,
      type: 'mastercard',
      number: '**** 5678',
      lastFour: '5678',
      name: 'JANE SMITH',
      expiry: '08/24',
      bank: 'Bank of America'
    },
    {
      id: 3,
      type: 'amex',
      number: '**** 9012',
      lastFour: '9012',
      name: 'ALEX JOHNSON',
      expiry: '05/26',
      bank: 'Citibank'
    }
  ];

  const handleCardSelect = (card) => {
    setSelectedCardId(card.id);
  };

  const handleConfirm = () => {
    if (selectedCardId) {
      const selectedCard = savedCards.find(card => card.id === selectedCardId);
      onCardSelect(selectedCard);
    }
  };

  const handleAddCard = () => {
    setShowAddCardForm(true);
  };

  const handleNewCardChange = (e) => {
    const { name, value } = e.target;
    setNewCard(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSaveNewCard = () => {
    // Validar y guardar nueva tarjeta
    if (newCard.number && newCard.name && newCard.expiry && newCard.cvv) {
      const newCardObj = {
        id: savedCards.length + 1,
        type: 'new',
        number: `**** ${newCard.number.slice(-4)}`,
        lastFour: newCard.number.slice(-4),
        name: newCard.name.toUpperCase(),
        expiry: newCard.expiry,
        bank: 'New Card'
      };
      
      // Aquí normalmente se enviaría a una API
      alert('¡Tarjeta agregada exitosamente!');
      setShowAddCardForm(false);
      setNewCard({ number: '', name: '', expiry: '', cvv: '' });
      setSelectedCardId(newCardObj.id);
    } else {
      alert('Por favor, rellene todos los datos de la tarjeta.');
    }
  };

  const getCardIcon = (type) => {
    switch(type) {
      case 'visa': return '💳';
      case 'mastercard': return '💳';
      case 'amex': return '💳';
      default: return '💳';
    }
  };

  return (
    <div className="card-selector">
      <div className="card-selector-header">
        <button className="back-button" onClick={onBack}>
          ←
        </button>
        <h2>Seleccionar Tarjeta</h2>
      </div>

      {showAddCardForm ? (
        <div className="add-card-form">
          <h3>Agregar tarjeta</h3>
          
          <div className="form-group">
            <label>Número de tarjeta</label>
            <input
              type="text"
              name="number"
              placeholder="1234 5678 9012 3456"
              value={newCard.number}
              onChange={handleNewCardChange}
              maxLength="19"
            />
          </div>
          
          <div className="form-group">
            <label>Titular de la tarjeta</label>
            <input
              type="text"
              name="name"
              placeholder="JOHN DOE"
              value={newCard.name}
              onChange={handleNewCardChange}
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>Vencimiento</label>
              <input
                type="text"
                name="expiry"
                placeholder="MM/YY"
                value={newCard.expiry}
                onChange={handleNewCardChange}
                maxLength="5"
              />
            </div>
            
            <div className="form-group">
              <label>CVV</label>
              <input
                type="password"
                name="cvv"
                placeholder="123"
                value={newCard.cvv}
                onChange={handleNewCardChange}
                maxLength="4"
              />
            </div>
          </div>
          
          <div className="form-actions">
            <button 
              className="action-btn secondary"
              onClick={() => setShowAddCardForm(false)}
            >
              Cancelar
            </button>
            <button 
              className="action-btn primary"
              onClick={handleSaveNewCard}
            >
              Guardar
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="saved-cards">
            <h3>Guardar Tarjetas</h3>
            <div className="cards-list">
              {savedCards.map(card => (
                <div
                  key={card.id}
                  className={`card-option ${selectedCardId === card.id ? 'selected' : ''}`}
                  onClick={() => handleCardSelect(card)}
                >
                  <div className="card-icon">{getCardIcon(card.type)}</div>
                  <div className="card-info">
                    <div className="card-header">
                      <span className="card-bank">{card.bank}</span>
                      <span className="card-type">{card.type.toUpperCase()}</span>
                    </div>
                    <div className="card-number">{card.number}</div>
                    <div className="card-details">
                      <span className="card-name">{card.name}</span>
                      <span className="card-expiry">Exp: {card.expiry}</span>
                    </div>
                  </div>
                  <div className="card-selector-indicator">
                    {selectedCardId === card.id ? '✓' : '○'}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button className="add-card-btn" onClick={handleAddCard}>
            + Agregar tarjeta
          </button>

          <div className="card-selector-actions">
            <button className="action-btn secondary" onClick={onBack}>
              <TiArrowBack />
            </button>
            <button 
              className="action-btn primary"
              onClick={handleConfirm}
              disabled={!selectedCardId}
            >
              Pagar Ahora
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CardSelector;